<script>
import {vMaska} from "maska";

export default {
  name: "ManageProviders",
  directives: {maska: vMaska},
  data: () => {
    return {
      providers: '',
      search: '',
      prov: {
        name: '',
        rtn: '',
      },
      editingProv: ''
    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredProv() {
      if (!this.search) {
        return this.providers;
      }
      return this.providers.filter(prov => prov.name.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    async getProvData() {
      try {
        let res = await this.$api.get("/auth/providers");
        if (res.status.toString() === "200") {
          this.providers = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async regProv() {
      if (this.prov.name.length < 3 || this.prov.rtn.length < 14) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          name: this.prov.name, rtn: this.prov.rtn
        }
        let result = await this.$api.post("/auth/providers", data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "201") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getProvData()
          this.prov = {
            name: '',
            rtn: '',
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los  cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        console.log("reg error", error)
        this.$swal.fire({
          icon: 'error',
          name: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async regProvChanges() {
      if (this.editingProv.name.length < 3 || this.editingProv.rtn.length < 14) {
        this.$swal.fire({
          icon: 'error',
          title: 'Verifique los datos nuevamente',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        });
        return
      }
      try {
        let data = {
          name: this.editingProv.name, rtn: this.editingProv.rtn,
        }
        let result = await this.$api.put(`/auth/providers/${this.editingProv.id}`, data, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        if (result.status.toString() === "200") {
          this.$swal.fire({
            icon: 'success',
            title: 'Se han guardado los cambios',
            customClass: {
              popup: 'mySwal'
            }
          })
          await this.getProvData()
          this.editingProv = ''
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'No se han podido registrar los cambios',
            text: '',
            customClass: {
              popup: 'mySwal'
            }
          });
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: 'No se han podido registrar los cambios',
          text: '',
          customClass: {
            popup: 'mySwal'
          }
        })
      }

    },
    editProv(prov) {
      this.editingProv = prov;
      this.getProvData()
    },
    cancelEdit() {
      this.editingProv = ''
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterName() {
      this.prov.name = this.prov.name.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },
    inputLimiterNameEdit() {
      this.editingProv.name = this.editingProv.name.replace(/[^a-z0-9 ()/%ñáéíóúü,.~\-"]/gi, '').trimStart();
    },

  },

  created() {
    this.getProvData()
  }
}

</script>

<template>
  <h1>Proveedores</h1>

  <div class="grid-container-left">

    <div>

      <form class="Form">
        <input type="text" v-model="search" v-on:input="inputLimiterSearch"
               placeholder="Buscar proveedor ...">
      </form>

      <div class="container mt-4 table-container" v-if="filteredProv.length > 0">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>RTN</th>
            <th v-if="sidebarData.includes('ad-prov-providers-edit')">Opciones</th>
          </tr>

          </thead>
          <tbody>

          <tr v-for="(prov, index) in filteredProv" :key="prov.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ prov.name }}</td>
            <td>{{ prov.rtn }}</td>
            <td class="td_align_center" v-if="sidebarData.includes('ad-prov-providers-edit')">
              <button class="tableBtn" @click="editProv(prov)" role="link">Editar</button>
            </td>
          </tr>

          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="bordered-p">No se encontraron proveedores.</p>
      </div>

    </div>
    <div v-if="sidebarData.includes('ad-prov-providers-reg') || editingProv">
      <div v-if="!editingProv">
        <h2>Registrar proveedor</h2>
        <form class="Form">
          <label>Nombre</label>
          <input type="text" v-model="prov.name"
                 placeholder="Nombre del proveedor" v-on:input="inputLimiterName">
          <label>RTN</label>
          <input type="text" v-model="prov.rtn" v-maska data-maska="##############">
          <button type="submit" @click.prevent="regProv">Registrar</button>
        </form>
      </div>

      <div v-if="editingProv">
        <h2>Editar Proveedor</h2>
        <form class="Form">
          <label>Nombre</label>
          <input type="text" v-model="editingProv.name" v-on:input="inputLimiterNameEdit">
          <label>RTN</label>
          <input type="text" v-model="editingProv.rtn" v-maska data-maska="##############">
          <button type="submit" @click.prevent="regProvChanges">Guardar Cambios</button>
          <button type="submit" @click.prevent="cancelEdit">Cancelar</button>
        </form>
      </div>

      <div>
      </div>

    </div>

  </div>

</template>

<style>
</style>